/**
 * Minimalny pool z limitem równoległości dla async zadań.
 * Używamy go, żeby nie odpalać naraz dziesiątek requestów (co dobija backend i przeglądarkę).
 */
export async function promisePool(items, worker, concurrency = 4) {
  if (!Array.isArray(items) || items.length === 0) return [];
  const limit = Math.max(1, Number(concurrency) || 1);

  const results = new Array(items.length);
  let nextIndex = 0;

  const runOne = async () => {
    while (true) {
      const idx = nextIndex++;
      if (idx >= items.length) return;
      results[idx] = await worker(items[idx], idx);
    }
  };

  const runners = Array.from({ length: Math.min(limit, items.length) }, () => runOne());
  await Promise.all(runners);
  return results;
}

